"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndefinedSourceError = void 0;
exports.UndefinedSourceError = new Error('source is undefined');
